<template>
  <div class="b-card-container">
    <div class="bc-header-container">
      <div class="bc-header">Contact Information</div>
      <div v-if="adminRole !== 'viewer'" class="bc-button-container">
        <button class="edit-btn" @click="setCustomerDetailEdit('contact-info')">Edit</button>
      </div>
    </div>
    <div class="bc-row-container">
      <div class="bc-column-container">
        <div class="bc-info-container">
          <div class="sac__font-14 n70">Name</div>
          <div class="sac__font-14">{{ customer.firstName }} {{ customer.lastName }}</div>
        </div>
        <div class="bc-info-container">
          <div class="sac__font-14 n70">Email</div>
          <div class="sac__font-14">
            {{ customer.email }}
          </div>
        </div>
        <div class="bc-info-container">
          <div class="sac__font-14 n70">Phone</div>
          <div class="sac__font-14">
            {{ customer.phone }}
          </div>
        </div>
        <div v-if="isSmacAdmin && customer.lastFourDigitCC" class="bc-info-container">
          <div class="sac__font-14 n70">Last 4 Digits of CC</div>
          <div class="sac__font-14">
            {{ customer.lastFourDigitCC }}
          </div>
        </div>
        <div v-if="isSmacAdmin && customer.expiryDateCC" class="bc-info-container">
          <div class="sac__font-14 n70">CC Expiry Date</div>
          <div class="sac__font-14">
            <span
              v-if="customer.expiryDateCC"
              :class="[
                isCardExpired === 'expired' ? 'red-text' : '',
                isCardExpired === 'expiring soon' ? 'orange-text' : '',
                isCardExpired === '' ? 'green-text' : '',
              ]"
            >
              {{ customer.expiryDateCC }}
            </span>
          </div>
        </div>
        <div v-if="isSmacAdmin" class="bc-info-container">
          <div class="sac__font-14 n70">Hubspot ID</div>
          <div class="sac__font-14">
            <span v-if="customer.hubspotId">
              {{ customer.hubspotId }}
            </span>
            <span v-else>--</span>
          </div>
        </div>
        <div v-if="customer.serviceTitanCustomerId" class="bc-info-container">
          <div class="sac__font-14 n70">ServiceTitan ID</div>

          <span v-if="isSmacAdmin" class="sac__font-14">
            {{ customer.serviceTitanCustomerId }}
          </span>
          <button v-else class="sac__font-14 f-primary" @click="navigateToServiceTitan">
            {{ customer.serviceTitanCustomerId }}
          </button>
        </div>
        <div v-if="customer.techFirstName || customer.techLastName" class="bc-info-container">
          <div class="sac__font-14 n70">Onboarded Technician</div>
          <div class="sac__font-14">{{ customer.techFirstName }} {{ customer.techLastName }}</div>
        </div>
        <div v-if="customer.note" class="bc-info-container">
          <div class="sac__font-14 n70">Technician Note</div>
          <div class="sac__font-14">
            {{ customer.note }}
          </div>
        </div>
        <div class="bc-info-container">
          <div class="sac__font-14 n70">Address</div>
          <div class="sac__font-14" v-if="serviceAddress">
            {{ serviceAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import CheckDateExpiry from '@shared/lib/general/CheckDateExpiry';

export default {
  name: 'ContactInfo',
  mixins: [customerDetailMixin],
  computed: {
    serviceAddress() {
      if (this.customer && Array.isArray(this.customer.serviceAddress)) {
        const sa = this.customer.serviceAddress[0];
        return sa.address1;
      }
      return null;
    },
    isCardExpired() {
      const { expiryDateCC } = this.customer;
      return CheckDateExpiry(expiryDateCC);
    },
  },
  methods: {
    navigateToServiceTitan() {
      const { serviceTitanCustomerId } = this.customer;

      if (!serviceTitanCustomerId) return;

      const url = `${process.env.ST_URL}/#/customer/${serviceTitanCustomerId}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.address-container {
  display: flex;
  align-items: baseline;
}

.notification-container {
  display: flex;
  gap: 1rem;
  margin-top: 10px;
  .cb-container {
    display: flex;
    gap: 10px;
    width: 48%;
    align-items: center;
  }
}

.v-icon.v-icon.v-icon--link {
  margin-right: 5px;
}

.red-text {
  color: $TOMATO100;
  font-weight: 500;
}
.orange-text {
  color: $SUNSET100;
  font-weight: 500;
}
.green-text {
  color: $BASIL100;
  font-weight: 500;
}
</style>
